import { graphql } from "gatsby";
import React, { createContext } from "react";

export interface PageNodesContextData {
  pageNodes: Queries.StandardPageDataFragment[];
  localizedUrls: Record<string, string>;
  currentPage?: Queries.StandardPageDataFragment;
}

export const PageNodesContext = createContext<PageNodesContextData>({
  pageNodes: [],
  localizedUrls: {},
});

export const query = graphql`
  fragment StandardPageData on ContentfulStandardPage {
    id
    contentful_id
    slug
    node_locale
    title
    breadcrumbTitle
    breadcrumbsColor
    breadcrumbsPosition
    breadcrumbsVariant
    defaultLocaleEntry {
      breadcrumbTitle
      title
    }
    parentPage {
      id
    }
  }
`;
